import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-working-days-of-week',
  templateUrl: './working-days-of-week.component.html',
  styleUrls: ['./working-days-of-week.component.scss'],
})
export class WorkingDaysOfWeekComponent implements OnInit {

  private dayOrder = (): Array<keyof ActiveDays> => ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  
  private weekdayAbbreviation = new Map<string, string>([
    ['sunday', 'Su'],
    ['monday', 'M'],
    ['tuesday', 'Tu'],
    ['wednesday', 'W'],
    ['thursday', 'Th'],
    ['friday', 'F'],
    ['saturday', 'Sa']
  ]);

  days: DayOfWeek[];

  get pTagClass() {
    return this.strikethrough ? 'strikethrough' : '';
  }
  
  @Input() strikethrough?: boolean;
  @Input() activeBackgroundColor: string = '#DEDFE8';
  @Input() activeTextColor: string = '#080912';
  @Input() textColor: string = '#888992';
  @Input() shouldUseWeekdayAbbrev?: boolean;
  @Input() activeDays: ActiveDays;
  @Input() weekStartsToday?: boolean = false;
  @Input() isSmallVersion?: boolean = false;

  ngOnInit() {
    const daysOfWeek = this.dayOrder();
    if (this.weekStartsToday) {
      let dayArray = [];
      const start = new Date().getDay();

      for (let i = start; i < daysOfWeek.length + start; i++) {
        dayArray.push(daysOfWeek[i % daysOfWeek.length]);
      }
      
      for(let i = 0; i < daysOfWeek.length; i++) {
        daysOfWeek[i] = dayArray[i];
      }
    }
    const days: DayOfWeek[] = daysOfWeek.map(day => ({
      char: this.shouldUseWeekdayAbbrev ? this.weekdayAbbreviation.get(day) : day.substring(0, 1).toUpperCase(),
      classes: {
        active: this.activeDays[day],
        // Second pass through days we'll set 'start'/'end' based on 'active' above
      }
    }));

    for (let i = 0; i < days.length; i++) {
      const currDay = days[i];
      if (currDay.classes.active) {
        const prevDay = (i > 0) ? days[i - 1] : undefined;
        if (!prevDay?.classes.active) {
          currDay.classes.start = true;
        }

        const nextDay = (i < (days.length - 1)) ? days[i + 1] : undefined;
        if (!nextDay?.classes.active) {
          currDay.classes.end = true;
        }
      }
    }

    this.days = days;
  }
}

export interface ActiveDays {
  sunday?: boolean;
  monday?: boolean;
  tuesday?: boolean;
  wednesday?: boolean;
  thursday?: boolean;
  friday?: boolean;
  saturday?: boolean;
};

interface DayClasses {
  active?: boolean;
  start?: boolean;
  end?: boolean;
}

interface DayOfWeek {
  char: string;
  classes: DayClasses;
}
